import '../styles/main.scss';

await import('./main.js');
